// API mengirim komoditi sebagai angka pada kolom `type` (sudah diperiksa ke
// /api/kategory/* dan /api/parameter-uji/*: nilainya angka JSON, bukan teks).
// Dipakai supaya label tidak lagi dipatok keras "Jenis Pangan" untuk semua
// komoditi.
const NAMA_KOMODITI = {
  1: "Pangan",
  2: "Kosmetik",
  3: "Obat",
  4: "Obat Bahan Alam",
};

// Kalau type tidak dikenali, pakai kata netral supaya tidak menyesatkan.
export const namaKomoditi = (type) => NAMA_KOMODITI[type] || "Produk";

export default namaKomoditi;
